export const webComponentList = [
  'va-accordion-item',
  'va-accordion',
  'va-alert',
  'va-breadcrumbs',
  'va-button-pair',
  'va-button',
  'va-checkbox-group',
  'va-checkbox',
  'va-combo-box',
  'va-file-input',
  'va-file-input-multiple',
  'va-memorable-date',
  'va-number-input',
  'va-privacy-agreement',
  'va-radio',
  'va-select',
  'va-telephone-input',
  'va-text-input',
  'va-textarea',
];

// Commented out components are wrappers that have an open shadow DOM
export const focusableWebComponentList = [
  'va-accordion-item',
  // 'va-accordion',
  'va-alert:not([visible="false"])',
  // 'va-breadcrumbs',
  // 'va-button-pair',
  'va-button',
  'va-checkbox-group',
  'va-checkbox',
  'va-combo-box',
  'va-file-input',
  'va-file-input-multiple',
  'va-memorable-date',
  'va-number-input',
  // 'va-privacy-agreement',
  'va-radio',
  'va-select',
  'va-text-input',
  'va-textarea',
  'va-telephone-input',
  'va-combo-box',
];

// Web components with a `label-header-level` property
export const webComponentsWithHeaders = [
  'va-checkbox-group',
  'va-radio',
  'va-textarea',
  'va-alert:not([visible="false"])',
];
